import { useState } from '@hookstate/core';
import { DeleteDialog, GlobalMenu } from '@components';
import { IInvite, InviteUserRole } from '@models/Invite.model';
import { patchInvite } from '@services/queries/invites/patchInvite/patchInvite';
import { useQueryClient, useMutation } from 'react-query';
import { toast } from 'react-toast';
import { useContext } from 'react';
import { NavigationContext } from '@layout/navigation/navigation';
import { Container } from './InvitationsMenu.styles';

interface IInvitationsMenu {
  data: IInvite;
}

const InvitationsMenu = ({ data }: IInvitationsMenu) => {
  const queryClient = useQueryClient();

  const { role } = useContext(NavigationContext);

  const openDeleteDialog = useState(false);
  const mutationPatchInvite = useMutation(patchInvite, {
    onSuccess: () => {
      queryClient.invalidateQueries(['profile']);
      toast.success('Invitation canceled');
      queryClient.invalidateQueries('invites');
    },
  });

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Actions"
        itemList={[
          {
            disabled: ![InviteUserRole.ADMIN].includes(role),
            disableToolTip: [InviteUserRole.ADMIN].includes(role),
            toolTipText: 'Only admins can cancel invitations.',
            toolTipId: 'cancelInviteTooltip',
            label: 'Cancel invitation',
            iconName: 'disable',
            onClick: () => {
              openDeleteDialog.set(true);
            },
          },
        ]}
      />

      <DeleteDialog
        open={openDeleteDialog}
        onDelete={() => {
          mutationPatchInvite.mutate({
            id: data.id,
            canceled: true,
          });
          openDeleteDialog.set(true);
        }}
      />
    </Container>
  );
};

export { InvitationsMenu };
